import type { LinkResponse } from '@models/link-response/link-response';
import type { RegisterIcon } from '@models/partner/menu/menu-icons';
import type { NavigationItemStatus } from '@models/partner/menu/plan-group-menu-response';

export type NavigationItemResponse = {
  id: string;
  label: string;
  isMandatory: boolean;
} & (ChildNavigation | MobileNavigation | ParentNavigation);

type NavigationItem = {
  status: NavigationItemStatus;
  link: NavigationItemLinkResponse;
  parentId: string | null;
};

type ChildNavigation = NavigationItem & {
  type: 'child';
};

export type ParentNavigation = NavigationItem & {
  type: 'parent';
  children: Array<ChildNavigation>;
};

type MobileNavigation = NavigationItem & {
  type: 'mobile';
  icon: RegisterIcon;
};

export type NavigationItemLinkResponse = LinkResponse | null;

export const DEFAULT_NAVIGATION_DESKTOP_ITEM: Omit<NavigationItemResponse, 'id'> = {
  type: 'parent',
  label: '',
  status: 'draft',
  link: null,
  parentId: null,
  isMandatory: false,
} as const;

export const DEFAULT_NAVIGATION_MOBILE_ITEM: Omit<NavigationItemResponse, 'id'> = {
  type: 'mobile',
  label: '',
  status: 'draft',
  link: null,
  parentId: null,
  isMandatory: false,
} as const;

export type CreateNavigationItemRequest = {
  status: NavigationItemStatus;
  label: string;
  link: NavigationItemLinkResponse;
  icon: RegisterIcon | null;
  parentId: string | null;
};
